<template>
  <NuxtLayout name="search-basic-layout">
    <!-- 桌機:固定最小寬度 + 橫向捲動,拖小視窗時三欄不被擠壓跑版(到斷點才切手機版) -->
    <div class="pc:overflow-x-auto">
    <div class="pc:min-w-[1024px]">
    <!-- max-h:結果少時整列縮到內容高度,footer 才不會被撐到一個畫面之後(nav:66px nav-border:1px 麵包屑:33px) -->
    <div class="flex pc:max-h-[calc(100dvh-66px-1px-33px)]">
      <!-- 桌機:左側篩選側欄 -->
      <SearchSidebar v-if="!isMobile && !isSidebarCollapsed"
                     @collapse="isSidebarCollapsed = true"></SearchSidebar>
      <div v-else-if="!isMobile"
           class="sidebar-collapsed"
           @click="isSidebarCollapsed = false">
        <el-icon :size="18">
          <ArrowRight />
        </el-icon>
        <span>{{ $t('filter.title') }}</span>
      </div>

      <!-- 右側區域:已套用條件(跨列表+地圖) + (列表 | 地圖) -->
      <div class="flex-1 min-w-0 flex flex-col">
        <!-- 已套用條件:桌機跨在列表與地圖上方(手機改放到搜尋列下方,見下) -->
        <AppliedConditionChips v-if="!isMobile"
                               :chips="appliedChips"
                               @clear-all="clearAllConditions"></AppliedConditionChips>

        <div class="flex flex-1 min-h-0 mobile:flex-col">
          <!-- 中間:結果列表 -->
          <div v-if="!isMobile || isShowSpaceList"
               class="flex flex-col flex-1 min-w-0 mobile:w-full overflow-y-auto">

            <!-- 手機:搜尋列(含篩選入口) -->
            <div v-if="isMobile"
                 class="border-b mt-[16px] pb-[20px]">
              <SearchBar :is-result="true"></SearchBar>
            </div>
            <!-- 手機:已套用條件放在搜尋列下方,緊鄰結果 -->
            <AppliedConditionChips v-if="isMobile"
                                   :chips="appliedChips"
                                   @clear-all="clearAllConditions"></AppliedConditionChips>

            <div ref="searchResultTitleRes"
                 class="flex flex-col">

              <div class="mb-[15px] pc:mt-[16px] flex items-center justify-between
          pc:pl-[30px] pc:pr-[20px] mobile:px-[16px] mobile:flex-wrap">
            <div class="relative flex items-baseline mobile:mb-4 mobile:min-w-full mobile:mt-2">
              <h3 class="text-osn-dark-grey-00 text-2xl font-bold mobile:text-xl">{{
                  isSeoText(seoType) ? getSeoTextByType(seoType).section1.resultTitle : $t('result.search_result')
                }}</h3>

              <div class="text-osn-grey-01 text-[16px] ml-[8px]">{{ $t('result.total', {t: total}) }}</div>
              <ShareButton v-if="shareTarget" compact class="ml-3 self-center"
                           :target="shareTarget"
                           :source="shareSource || 'combo_share'"></ShareButton>
              <!-- 手機版 -->
              <div v-if="isMobile"
                   class="absolute top-[50%] translate-y-[-50%] right-0 text-osn-black-00 text-[16px] py-[4px] px-[12px] border border-solid border-osn-black-00 rounded-[20px]"
                   @click="isShowSpaceList = !isShowSpaceList">
                <div class="flex items-center">
                  <svg-icon :name="isShowSpaceList ? 'to_map' : 'to_list'"
                            size="20"
                            class="mr-[3px]"/>
                  {{ isShowSpaceList ? $t('map_list.to_map') : $t('map_list.to_list') }}
                </div>
              </div>
            </div>
            <div v-if="!isMobile || isShowSpaceList">
              <SearchResultsSorter></SearchResultsSorter>
            </div>
          </div>

          <!-- seo 文字 section0 -->
          <section v-if="isSeoTextComputed"
                   class="seo-section-0">
            <h1 class="seo-h1">{{ getSeoTextByType(seoType).section0.h1 }}</h1>
            <p class="seo-p">{{ getSeoTextByType(seoType).section0.p }}</p>
          </section>

          <div class="relative h-full">
            <div v-if="!isMobile || isShowSpaceList"
                 class="">
              <div v-if="total === 0"
                   class="mt-[12px] pc:px-[30px] mobile:px-[16px] flex items-center text-[14px] text-osn-grey-01">
                <svg-icon name="magnifier"
                          size="18"
                          class="mr-[6px]"></svg-icon>
                {{ $t('result.no_result') }}
              </div>
              <div v-if="total === 0"
                   class="mt-[16px] mb-[8px] pc:px-[30px] mobile:px-[16px] font-bold text-[18px] text-osn-dark-grey-00">
                {{ $t('result.recommend_space') }}
              </div>
              <SpaceListWrapper class="pc:ml-[30px] mobile:px-[15px]"></SpaceListWrapper>

              <div class="bg-osn-grey-04 pc:py-[18px] pc:px-11 mobile:p-[12px]">
                <!-- seo 文字 section1 -->
                <section v-if="isSeoTextComputed"
                         class="seo-section pc:mb-4">
                  <h2 class="seo-h2">
                    <svg-icon name="question_mark_fill"
                              size="20"
                              class="mr-1"/>
                    {{ getSeoTextByType(seoType).section1.h2 }}
                  </h2>
                  <p class="seo-p">{{ getSeoTextByType(seoType).section1.p }}</p>


                  <!--                  新補上價格-->
                  <ul v-if="getSeoTextByType(seoType).section1.priceList">
                    <li v-for="priceGroup in getSeoTextByType(seoType).section1.priceList"
                        :key="priceGroup.region"
                        class="mt-2">
                      <p class="text-[14px] font-bold text-osn-dark-grey-00">{{ priceGroup.region }}</p>
                      <ul class="list-disc list-inside mt-2 space-y-1 text-[12px]">
                        <li v-for="priceItem in priceGroup.prices"
                            :key="priceItem.type">
                          <span class="font-bold">{{ priceItem.type }}：</span>{{ priceItem.price }}
                        </li>
                      </ul>
                    </li>
                  </ul>


                </section>

                <!-- seo 文字 section2 -->
                <section v-if="isSeoTextComputed"
                         class="seo-section my-4 pt-2">
                  <h2 class="seo-h2">
                    <svg-icon name="question_mark_fill"
                              size="20"
                              class="mr-1"/>
                    {{ getSeoTextByType(seoType).section2.h2 }}
                  </h2>
                  <h3 v-if="getSeoTextByType(seoType).section2.h3" class="mt-2 ml-2">
                    {{ getSeoTextByType(seoType).section2.h3 }}
                  </h3>
                  <ul class="mt-4 list-disc ml-4">
                    <li v-for="item in getSeoTextByType(seoType).section2.list">
                      <p class="seo-h3">{{ item.p1 }}</p>
                      <p class="seo-p">{{ item.p }}</p>
                    </li>
                  </ul>
                </section>
                <!-- seo 文字 section2_1 -->
                <section v-if="isSeoTextComputed && getSeoTextByType(seoType)?.section2_1"
                         class="seo-section my-4 pt-2">
                  <ul class="mt-4 list-disc ml-4">
                    <li v-for="item in getSeoTextByType(seoType).section2_1.list"
                        :key="item.h3">
                      <h3 class="seo-h3">{{ item.h3 }}</h3>
                      <p class="seo-p">{{ item.p }}</p>
                    </li>
                  </ul>
                </section>

                <!-- seo 文字 section3 -->
                <section v-if="isSeoTextComputed"
                         class="seo-section mt-4 pt-2">
                  <h2 class="seo-h2">
                    <svg-icon name="question_mark_fill"
                              size="20"
                              class="mr-1"/>
                    {{ getSeoTextByType(seoType).section3.h2 }}
                  </h2>
                  <ul class="mt-4">
                    <li v-for="item in getSeoTextByType(seoType).section3.list">
                      <h3 class="seo-h3">{{ item.h3 }}</h3>
                      <p class="seo-p">{{ item.subTitle }}</p>
                      <ul class="list-disc">
                        <li v-for="ulItem in item.ul">{{ ulItem }}</li>
                      </ul>
                    </li>
                  </ul>
                  <div>
                    <!-- 延伸閱讀 furtherReading -->
                    <div v-if="getSeoTextByType(seoType)?.section3?.furtherReading?.length" class="mt-4">
                      <h3 class="seo-h3">延伸閱讀</h3>
                      <ul class="list-disc ml-4">
                        <li v-for="(fr, idx) in getSeoTextByType(seoType).section3.furtherReading"
                            :key="fr.link || idx">
                          <a :href="fr.link"
                             target="_blank"
                             rel="noopener"
                             class="underline text-osn-dark-grey-00">
                            {{ fr.title }}
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </section>
              </div>


              <!-- seo 文字 section4 -->
              <section v-if="isSeoTextComputed"
                       class="seo-section-bottom pt-2 border-t bg-osn-yellow-00">

                <h2 class="seo-h2">{{ getSeoTextByType(seoType).section4.h2 }}</h2>
                <ul class="mt-4">
                  <li v-for="(item, idx) in getSeoTextByType(seoType).section4.list"
                      :key="item.title || idx">
                    <svg-icon :name="item.icon"
                              size="24"
                              class="pc:mb-2 mobile:flex-shrink-0 mobile:mr-[10px]"/>
                    <div>
                      <div class="seo-li-title">{{ item.title }}</div>
                      <p class="seo-p">{{ item.p }}</p>
                    </div>
                  </li>
                </ul>


              </section>
            </div>
          </div>
        </div>
          </div>

          <!-- 右半邊的地圖 -->
          <div v-if="(!isMobile && !isMapCollapsed) || (isMobile && !isShowSpaceList)"
           class="relative pc:w-[25%] flex-shrink-0 mobile:w-full h-full mobile:h-[calc(100dvh-66px-1px-33px)]">
        <Map class="flex-1"
             @to-list="isMapCollapsed = true"></Map>
        <div v-if="isMobile"
             class="absolute top-[10px] right-[10px] text-osn-black-00 text-[16px] py-[4px] px-[12px] rounded-[20px] bg-white"
             @click="isShowSpaceList = true">
          <div class="flex items-center">
            <svg-icon name="to_list"
                      size="20"
                      class=""/>
            {{ $t('map_list.to_list') }}
          </div>
        </div>
      </div>

      <!-- 桌機:地圖收合後的「顯示地圖」浮鈕 -->
      <div v-if="!isMobile && isMapCollapsed"
           class="show-map-btn"
           @click="isMapCollapsed = false">
        <svg-icon name="to_map"
                  size="20"
                  class="mr-[4px]" />
        {{ $t('map_list.to_map') }}
      </div>
        </div>
      </div>
    </div>
    <!-- footer 跨三欄,放在最下方(全寬);與上方內容留 20px -->
    <Footer class="pc:mt-[20px]"></Footer>
    </div>
    </div>
  </NuxtLayout>
</template>
<script setup
        lang="ts">

import {computed, nextTick, ref, onMounted, provide, toRefs} from "vue";
import {ArrowRight} from "@element-plus/icons-vue";
import SearchBar from "@/components/SearchIndex/SearchBarWrapper/SearchBar.vue";
import SearchSidebar from "@/components/SearchResult/SearchSidebar.vue";
import AppliedConditionChips from "@/components/SearchResult/AppliedConditionChips.vue";
import SearchResultsSorter from "@/components/SearchResult/SearchResultsSorter.vue";
import SpaceListWrapper from "@/components/SearchResult/SpaceList/SpaceListWrapper.vue";
import ShareButton from "@/components/Share/ShareButton.vue";
import Map from "@/components/SearchResult/Map.vue";
import Footer from "@/components/Footer/Footer.vue";


import {useSearchQueryStore} from "@/stores/searchQuery.js";
import {useSettingStore} from "@/stores/setting";
import {useSearchResultStore} from "@/stores/searchResult";
import {useAppliedConditions} from "@/composables/useAppliedConditions";
import {getSeoText} from "@/config/seoText.js";

const route = useRoute();
const router = useRouter()
const settingStore = useSettingStore()
const searchQueryStore = useSearchQueryStore()
const searchResultStore = useSearchResultStore()
const {chips: appliedChips, clearAll: clearAllConditions} = useAppliedConditions()
const isMobile = computed(() => settingStore.isMobile);
const total = computed(() => searchResultStore.getSpaceListTotal);
// const recommendSpaceList = computed(() => searchResultStore.getRecommendSpaceList);

// const _usageCategoryId = useRouteQuery('_usageCategoryId')


/*const props = defineProps({
  seoType: {
    type: Array,
    default: []
  }
})*/

const props = defineProps<{
  seoType: string[]
  // Phase 1 SEO 組合頁:有傳就用它當 seoText(h1/標題/sections);沒傳走原本 getSeoText(既有頁零影響)
  seoOverride?: Record<string, unknown> | null
  // Phase 2:組合頁分享(有傳才顯示分享鈕;/search-result 與單段不傳=不顯示,向下相容)
  shareTarget?: string
  shareSource?: string
}>()
const { seoType } = toRefs(props)

const isSeoTextComputed = computed(() => isSeoText(seoType.value));

const searchResultTitleRes = ref(null);
const isShowSpaceList = ref(true);
// 桌機:側欄收合、地圖收合(列表檢視)
const isSidebarCollapsed = ref(false);
const isMapCollapsed = ref(false);

const layoutProps = {
  footer: false
};
provide('searchBasicLayoutProps', layoutProps);

onMounted(() => {
  // slideTo() 會把整頁捲動(footer 全寬後頁面可捲),導致 header 被捲走;改不自動捲動,維持在頁首
  // slideTo();

  /* if (route.query.sid) {
     router.push({path: `/space/${route.query.sid}`})
   }

   slideTo();

   // 檢查是否有有效的查詢參數
   const hasValidQuery = (query) => query && Object.keys(query).length > 0;

   // 處理路由查詢參數的主邏輯
   const processRouteQuery = (query) => {
     setSearchQueryRouteToStore(query);
     handleSearchWithStore();
   };

   // 主執行流程
   if (hasValidQuery(route.query)) {
     processRouteQuery(route.query);
   }*/

})


function slideTo() {
  nextTick(() => {
    searchResultTitleRes.value.scrollIntoView();
  })
}

const isSeoText = (typeArray) => {
  return getSeoTextByType(typeArray)
};

const getSeoTextByType = (typeArray) => {
  if (props.seoOverride) {
    return props.seoOverride;
  }
  if (!Array.isArray(typeArray) || typeArray.length === 0) {
    return null;
  }
  return getSeoText(typeArray[0]);
}


</script>

<style scoped
       lang="scss">
.seo-section-0 {
  @apply pc:mx-auto pc:pl-[30px] mb-5  px-5 mobile:text-base;
  .seo-h1 {
    @apply text-[20px] mobile:leading-[24px] font-bold;
  }

  .seo-p {
    @apply mt-4 text-[14px] text-osn-grey-01;
  }
}

.seo-section {
  @apply bg-osn-white-00 rounded-[20px] text-osn-grey-01
  pc:p-4
  mobile:p-[12px];

  .seo-h2 {
    @apply text-[14px] font-bold flex items-center text-osn-dark-grey-00;
  }

  .seo-p {
    @apply mt-2 text-[12px] mobile:text-[14px];
  }

  .seo-h3 {
    @apply mt-2 text-[12px] mobile:text-[14px];
  }

  ul {
    @apply mt-2;
    li {
      @apply ml-[12px] text-[12px];
      .seo-li-title {
        @apply font-bold;
      }
    }
  }
}

.seo-section-bottom {
  @apply py-[20px] text-osn-grey-01 pc:px-[30px] mobile:px-[12px];

  .seo-h2 {
    @apply font-semibold text-osn-dark-grey-00 text-[14px];
  }

  .seo-p {
    @apply mt-2;
  }

  ul {
    @apply mt-2 flex mobile:flex-wrap text-[12px];
    li {
      @apply w-1/3 mobile:w-full mt-2 mr-[30px] mobile:flex mobile:mb-[10px];
      .seo-li-title {
        @apply pc:mb-[10px] font-semibold text-osn-dark-grey-00;
      }
    }
  }
}

.space-list-wrap {
  @apply absolute w-[400px] top-0 bottom-0 left-1.5 z-50;
}

.sidebar-collapsed {
  @apply flex-shrink-0 w-[48px] h-full flex flex-col items-center pt-[16px] gap-[6px]
  border-r border-osn-grey-03 text-[14px] text-osn-dark-grey-00 cursor-pointer;
  writing-mode: vertical-rl;
}

.show-map-btn {
  @apply absolute bottom-[24px] right-[24px] flex items-center px-[16px] h-[40px] text-[14px]
  text-osn-dark-grey-00 bg-osn-white-00 rounded-[8px] shadow-md cursor-pointer z-50;
}
</style>
